import styled from "styled-components"
import {Modal as StandardModal} from "react-bootstrap/lib"

import padding from "@irati/ui/src/global/padding"
import CloseBase from "@irati/ui/src/Close"
import {IconButton} from "@irati/ui/src/Button"

interface ImageModalProps {
  margintop?: number
}
export const ImageModal = styled(StandardModal)<ImageModalProps>`
  .modal-content{
    ${({margintop}) => margintop && `margin-top: ${margintop}px;`}
  }
`

export const ModalInner = styled.div`
  padding: ${padding.small};
  padding-top: 40px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    padding: ${padding.medium};
  `}
`

export const Close = styled(CloseBase)`
  top: 10px;
  right: 10px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    top: 20px;
    right: 20px;
  `}
`

export const Back = styled(IconButton)`
  position: absolute;
  top: 10px;
  left: 10px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    top: 20px;
    left: 20px;
  `}
`
